import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import type { MessageStatus } from './hooks';
import { errorCodeText } from './errorCodeText';

// Цвета согласованы с design + AntD-палитрой:
//   queued/sending — processing (синий)
//   sent/delivered — success (бирюзовый)
//   failed         — error (красный)
//   skipped        — warning (оранжевый, M3.5+ — quota_exceeded_*)
const STATUS_COLORS: Record<MessageStatus, string> = {
  queued: 'default',
  sending: 'processing',
  sent: 'success',
  delivered: 'success',
  failed: 'error',
  skipped: 'warning',
};

interface MessageStatusTagProps {
  status: MessageStatus;
  /**
   * Для статусов failed/skipped — оборачивает Tag в Tooltip с
   * человекочитаемым переводом кода через `messages.errors.<code>`.
   * Если код null/неизвестен — Tooltip не показывается (status-only).
   */
  errorCode?: string | null;
}

export function MessageStatusTag({ status, errorCode }: MessageStatusTagProps): JSX.Element {
  const { t } = useTranslation();
  const tag = <Tag color={STATUS_COLORS[status]}>{t(`messages.status.${status}`)}</Tag>;

  const showTooltip = (status === 'failed' || status === 'skipped') && Boolean(errorCode);
  if (!showTooltip) return tag;

  const text = errorCodeText(t, errorCode);
  return <Tooltip title={text}>{tag}</Tooltip>;
}
